export interface ResolutionConfig {
  [key: string]: { min: number; max: number; resolution: string }[];
}

export const resolutionConfig: ResolutionConfig = {
  st_stage_home: [
    { min: 0, max: 560, resolution: 'hero_x2' },
    { min: 560, max: 768, resolution: 'hero_mobile_x2' },
    { min: 768, max: 990, resolution: 'hero_x2' },
    { min: 990, max: 1200, resolution: 'hero_mobile_x2' },
    { min: 0, max: Infinity, resolution: 'hero_x2' }, // Default
  ],
  st_stage: [
    { min: 0, max: 768, resolution: 'header_section_ueber_footer_mobile_x2' },
    { min: 0, max: Infinity, resolution: 'header_section_ueber_footer_x2' }, // Default
  ],
  st_stage_temp: [
    { min: 0, max: 768, resolution: 'header_section_ueber_footer_mobile_x2' },
    { min: 0, max: Infinity, resolution: 'header_section_ueber_footer_x2' }, // Default
  ],
  st_teaser: [
    { min: 0, max: 768, resolution: 'teaser_mobile_x2' },
    { min: 0, max: Infinity, resolution: 'teaser_x2' }, // Default
  ],
  st_teasers: [
    { min: 0, max: 768, resolution: 'teasers_mobile_x2' },
    { min: 0, max: Infinity, resolution: 'teasers_x2' }, // Default
  ],
  st_teasers_temp: [
    { min: 0, max: 768, resolution: 'teasers_mobile_x2' },
    { min: 0, max: Infinity, resolution: 'teasers_x2' }, // Default
  ],
  st_teasers_quer: [
    { min: 0, max: 768, resolution: 'querteaser_mobile_x2' },
    { min: 0, max: Infinity, resolution: 'querteaser_x2' }, // Default
  ],
  st_deeplink: [
    { min: 0, max: 1200, resolution: 'querverlinkung_mobile_x2' },
    { min: 0, max: Infinity, resolution: 'querverlinkung_x2' }, // Default
  ],
  st_linktiles: [
    { min: 0, max: 560, resolution: 'toolboxen_mobile_x2' },
    { min: 560, max: 768, resolution: 'toolboxen_x2' },
    { min: 768, max: 990, resolution: 'toolboxen_mobile_x2' },
    { min: 0, max: Infinity, resolution: 'toolboxen_x2' }, // Default
  ],
  st_prefooter: [
    { min: 0, max: 768, resolution: 'header_section_ueber_footer_mobile_x2' },
    { min: 0, max: Infinity, resolution: 'header_section_ueber_footer_x2' }, // Default
  ],
  st_podcasts: [
    { min: 0, max: Infinity, resolution: 'podcast_x2' }, // Default
  ],
  st_download_container: [
    { min: 0, max: Infinity, resolution: 'download_x2' }, // Default
  ],
  default: [{ min: 0, max: Infinity, resolution: 'ORIGINAL' }],
};
